/* JILLBERT time-gated promo display - browser fallback (drafted 2026-11-03, NOT live).
   Shopify can serve a cached page rendered before/after a promo window. This re-checks the
   time on the visitor's device and fixes prices/labels/badges. Keep epochs in sync with
   snippets/jb-promo.liquid. Display only; the real discounts are the automatic discounts. */
(function () {
  var STYLE = 'strike'; // 'strike' (option A) or 'badge' (option B) - must match jb-promo.liquid
  var W = [
    { key: '1111',  from: 1794348000, to: 1794520800, arc: false, bp: 2500, label: '11.11 \u00b7 25% OFF' },
    { key: 'arc40', from: 1794348000, to: 1794520800, arc: true,  bp: 4000, label: 'ARCHIVE 40% OFF' },
    { key: 'novat', from: 1795298400, to: 1795903200, arc: false, bp: 1525, label: 'NO VAT' }
  ];
  function promoFor(arc, gift) {
    if (gift) return null;
    var n = Date.now() / 1000;
    for (var i = 0; i < W.length; i++) {
      if (W[i].arc === arc && n >= W[i].from && n < W[i].to) return W[i];
    }
    return null;
  }
  // Shop money format is "{{amount}} NIS" -> "1,093.28 NIS"
  function money(cents) {
    var s = (cents / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1] + ' NIS';
  }
  function fixPrice(el) {
    var d = el.dataset;
    var base = parseInt(d.jbPrice, 10), cmp = parseInt(d.jbCmp, 10) || 0;
    if (!base) return;
    var p = promoFor(d.jbArc === '1', d.jbGift === '1');
    var applies = !!(p && STYLE === 'strike' && d.jbAvail === '1');
    var want = applies ? p.key : '';
    if ((d.jbState || '') === want) return;
    var final = applies ? base - Math.floor(base * p.bp / 10000) : base;
    var strike = applies ? Math.max(cmp, base) : cmp;
    var regular = el.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
    for (var i = 0; i < regular.length; i++) regular[i].textContent = money(final);
    var s = el.querySelector('.price__sale s.price-item--regular');
    if (s) s.textContent = money(strike || base);
    el.classList.toggle('price--on-sale', strike > final);
    if (applies) el.classList.remove('price--no-compare');
    var lab = el.querySelector('.jb-promo-label');
    if (lab) { lab.textContent = applies ? p.label : ''; lab.hidden = !applies; }
    d.jbState = want;
  }
  function fixBadge(el) {
    var d = el.dataset;
    var p = promoFor(d.jbArc === '1', d.jbGift === '1');
    var show = !!(p && STYLE === 'badge' && d.jbAvail === '1');
    var want = show ? p.key : '';
    if ((d.jbState || '') === want) return;
    el.textContent = show ? p.label : '';
    el.hidden = !show;
    d.jbState = want;
  }
  function run(root) {
    var r = root || document;
    var a = r.querySelectorAll('[data-jb-price]');
    for (var i = 0; i < a.length; i++) fixPrice(a[i]);
    var b = r.querySelectorAll('.jb-promo-badge');
    for (var j = 0; j < b.length; j++) fixBadge(b[j]);
  }
  function start() {
    run();
    // variant changes, quick add, predictive search and infinite scroll inject new price HTML
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); })
        .observe(document.body, { childList: true, subtree: true });
    }
    // flip at the window boundary even if the page stays open
    setInterval(run, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
